export enum AnalyticsEvent {
  PAGE_VIEWED = 'page_viewed',

  SIGNED_IN_EMAIL = 'signed_in_email',
  SIGNED_IN_EMAIL_FAILED = 'signed_in_email_failed',
  SIGNED_UP_EMAIL = 'signed_up_email',
  SIGNED_UP_EMAIL_FAILED = 'signed_up_email_failed',
  SIGNED_IN_GOOGLE = 'signed_in_google',
  SIGNED_IN_GOOGLE_FAILED = 'signed_in_google_failed',
  SIGNED_UP_GOOGLE = 'signed_up_google',
  SIGNED_UP_GOOGLE_FAILED = 'signed_up_google_failed',

  CREATE_AGENT_STARTED = 'create_agent_started',
  AGENT_INFO_PROVIDED = 'agent_info_provided',
  AGENT_TRAINING_STARTED = 'agent_training_started',
  AGENT_CREATED = 'agent_created',
  AGENT_CREATION_FAILED = 'agent_creation_failed',
  KNOWLEDGE_FILE_UPLOADED = 'knowledge_file_uploaded',
  KNOWLEDGE_FILE_DELETED = 'knowledge_file_deleted',

  AVATAR_CREATION_STARTED = 'avatar_creation_started',
  AVATAR_TYPE_SELECTED = 'avatar_type_selected',
  AVATAR_SELECTED = 'avatar_selected',
  TRAINING_VIDEO_UPLOADED = 'training_video_uploaded',
  TRAINING_VIDEO_VERIFIED = 'training_video_verified',
  TRAINING_VIDEO_REJECTED = 'training_video_rejected',
  CONSENT_RECORDING_STARTED = 'consent_recording_started',
  CONSENT_VERIFIED = 'consent_verified',
  CONSENT_REJECTED = 'consent_rejected',
  AVATAR_TRAINING_LAUNCHED = 'avatar_training_launched',
  AVATAR_TRAINING_LAUNCH_FAILED = 'avatar_training_launch_failed',

  TTV_STARTED = 'ttv_started',
  VIDEO_CREATION_STARTED = 'video_creation_started',

  API_KEY_CREATED = 'api_key_created',
  API_KEY_CREATION_FAILED = 'api_key_creation_failed',
  API_KEY_COPIED = 'api_key_copied',
  API_KEY_COPIED_FAILED = 'api_key_copied_failed',

  STARTER_PROMO_SELECTED = 'starter_promo_selected',
  UPGRADE_SUBSCRIPTION_CLICKED = 'upgrade_subscription_clicked',
  MANAGE_BILLING_CLICKED = 'manage_billing_clicked',
  MANAGE_BILLING_FAILED = 'manage_billing_failed',
  SUBSCRIPTION_UPGRADED = 'subscription_upgraded',
  SUBSCRIPTION_DOWNGRADED = 'subscription_downgraded',
  SUBSCRIPTION_PROCESSING_FAILED = 'subscription_processing_failed',
  CANCELLATION_REASON_SUBMITTED = 'cancellation_reason_submitted',

  ONBOARDING_COMPLETED = 'onboarding_completed',

  MESSAGE_REACTION = 'message_reaction',

  FEEDBACK_INITIATED = 'feedback_initiated',
  FEEDBACK_SUBMITTED = 'feedback_submitted',
  FEEDBACK_SUBMISSION_FAILED = 'feedback_submission_failed',

  MFA_ENROLLMENT_STARTED = 'mfa_enrollment_started',
  MFA_ENROLLED = 'mfa_enrolled',
  MFA_ENROLLMENT_FAILED = 'mfa_enrollment_failed',
  MFA_UNENROLLED = 'mfa_unenrolled',
  MFA_CHALLENGE_COMPLETED = 'mfa_challenge_completed',
  MFA_CHALLENGE_FAILED = 'mfa_challenge_failed',
}

export enum AnalyticsProduct {
  APP = 'app',
  TEXT_TO_VIDEO = 'text_to_video',
  AVATAR_CREATION = 'avatar_creation',
  AGENT_CREATION = 'agent_creation',
  API_KEY = 'api_key',
  SUBSCRIPTION = 'subscription',
  AUTH = 'auth',
}

export enum AnalyticsSource {
  AGENTS_LIST = 'agents_list',
  AVATARS_LIST = 'avatars_list',
  HOME_QUICK_ACTION = 'home_quick_action',
  HOME_AGENT_LIBRARY = 'home_agent_library',
  HOME_AVATAR_LIBRARY = 'home_avatar_library',
}

type AnalyticsPropertyValue = string | number | boolean | null | undefined;

export type AnalyticsProperties = Record<string, AnalyticsPropertyValue> & {
  product?: AnalyticsProduct;
  source?: AnalyticsSource;
};
